// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"6200045d","196":"7e27aa76","276":"a5572a6f","479":"33a8cb07","579":"e6db5130","589":"844b89c4","774":"8aa97516","852":"e6db5130","895":"8cc79d0e"}[chunkId] + ".chunk.css";
};